/* Svensk katalog for locale-bank-misc-no.js (del 3 av 3).
 * Nøkler som mangler her, vises på engelsk. */
window.PlummeI18n.register('sv', {
  'bank.guided.tabHandling': 'Att hantera · {{count}}',
  'bank.guided.tabDeviation': 'Skapar avvikelse · {{count}}',
  'bank.guided.postsCauseDeviation': '{{count}} bokförda poster skapar avvikelse',
  'bank.guided.linkHelp': 'Koppla kvitto eller faktura till inköpet. Om dokumentationen inte finns väljer du ”Utan verifikation” så att valet sparas och kan kontrolleras senare.',
  'bank.guided.purchasesMissing': '{{count}} inköp saknar verifikation.',
  'bank.guided.noneMissing': 'Inga verifikationer saknas.',
  'bank.guided.ctl.allHandled': 'Alla betalningar är hanterade',
  'bank.guided.ctl.remaining': '{{count}} återstår',
  'bank.guided.ctl.vouchersLinked': 'Nödvändiga verifikationer är kopplade',
  'bank.guided.ctl.missingVouchers': '{{count}} saknar verifikation',
  'bank.guided.ctl.statementBalances': 'Kontoutdragets saldon stämmer',
  'bank.guided.ctl.deviation': 'Avvikelse {{amount}}',
  'bank.guided.ctl.ledgerBalance': 'Bokfört banksaldo stämmer',
  'bank.guided.ctl.clear': 'Klart',
  'bank.guided.finishNote': 'När du slutför kontrollerar Plumme saldona, låser perioden och flyttar kontoutdraget till arkivet.',
  'bank.guided.allChecked': 'Allt är kontrollerat och klart.',
  'bank.guided.resolveToFinish': 'Lös punkterna ovan för att låsa upp slutförandet.',
  'bank.guided.toast.noPending': 'Inga förslag väntar på godkännande.',
  'bank.guided.superLinks': 'SuperPlumma kopplar',
  'bank.guided.approveSuggestions': 'Godkänn förslagen',
  'bank.guided.note.tapPurchase': 'Tryck på en verifikation och sedan på inköpet du vill koppla den till.',
  'bank.guided.note.tapSuggestion': 'Tryck på en verifikation och sedan på förslaget. Möjliga träffar markeras i listan.',
  'bank.guided.note.dragPurchase': 'Dra en verifikation till inköpet du vill koppla den till.',
  'bank.guided.note.dragSuggestion': 'Dra en verifikation till ett förslag. Möjliga träffar markeras i listan.',
  'bank.guided.err.checkImportFirst': 'Kontrollera importövergången först.',
  'bank.guided.toast.postingVoided': 'Konteringen är annullerad',
  'bank.guided.archiving': 'Arkiverar…',
  'bank.guided.archiveNote': 'Kontrollen låses och flyttas till arkivet. Bankraderna bokfördes redan när de godkändes.',
  'bank.archive.lockedNote': 'Avstämningen är låst. Expandera en rad för att se verifikation och bokföring. Konto, moms och intern beskrivning kan korrigeras utan att bankbeloppet ändras.',
  'bank.archive.searchPh': 'Sök i konteringar',
  'bank.archive.searchHelp': 'Sök på datum, beskrivning, belopp, konto eller verifikation.',
  'bank.archive.countOf': '{{shown}} av {{total}} konteringar',
  'bank.archive.handled': 'Hanterad',
  'bank.archive.code': 'Kod {{code}}',
  'bank.archive.auditTrail': 'Verifikationskedja',
  'bank.archive.correctionsOne': '{{count}} korrigering',
  'bank.archive.correctionsMany': '{{count}} korrigeringar',
  'bank.archive.noCorrections': 'Inga korrigeringar',
  'bank.archive.internalDescription': 'Intern beskrivning',
  'bank.archive.noVoucher': 'Ingen verifikation kopplad',
  'bank.archive.noMatch': 'Inga konteringar matchar sökningen eller filtren.',
  'bank.archive.err.correctFailed': 'Det gick inte att korrigera konteringen.',
  'bank.importFix.err.openFirst': 'Öppna kopplingen eller konteringen innan inläsningen korrigeras.',
  'bank.importFix.err.reasonLine': 'Skriv kort varför bankraden korrigeras.',
  'bank.importFix.err.amountNumber': 'Beloppet måste vara ett tal.',
  'bank.importFix.removeFromRecon': 'Ignorera rad',
  'bank.importFix.warnTitle': 'Använd bara om PDF/CSV har lästs in fel.',
  'bank.importFix.warnBody': 'Detta ändrar inte banken eller bokförda verifikationer. Originalvärdena behålls i historiken.',
  'bank.importFix.blocked': 'Raden är redan kopplad eller bokförd. Öppna kopplingen/konteringen innan själva inläsningen korrigeras.',
  'bank.importFix.originalRead': 'Ursprungligt inläst',
  'bank.importFix.effect': 'Effekt på avstämningen',
  'bank.importFix.deviationNow': 'Avvikelse nu:',
  'bank.importFix.afterCorrection': 'Efter korrigering:',
  'bank.importFix.stillDeviates': 'Om avvikelsen fortfarande kvarstår, kontrollera om IB/UB också har lästs in fel.',
  'bank.importFix.fixLine': 'Rätta raden',
  'bank.importFix.removeMisread': 'Ignorera rad',
  'bank.ignoreLine': 'Ignorera rad',
  'bank.ignoreLineHelp': 'Använd detta bara när raden är felinläst och inte finns i kontoutdraget. Raden behålls i historiken.',
  'bank.ignoreLineConfirm': 'Ignorera raden',
  'bank.ignoreLineReason': 'Varför ignoreras raden?',
  'bank.ignoreLineReasonHint': 'Krävs för verifikationskedjan.',
  'bank.ignoreLineReasonPlaceholder': 'T.ex. raden finns inte i kontoutdraget',
  'bank.importFix.removeNote': 'Raden ligger kvar i historiken men räknas som 0,00 kr och anses klar i avstämningen. Används bara när raden inte finns i kontoutdraget.',
  'bank.importFix.whyReading': 'Varför korrigeras inläsningen?',
  'bank.importFix.whyReadingPh': 'T.ex. OCR läste fel belopp / raden finns inte i kontoutdraget',
  'bank.importFix.err.balancesNumber': 'IB och UB måste vara tal.',
  'bank.importFix.err.reasonBalance': 'Skriv kort varför saldot korrigeras.',
  'bank.importFix.saveBalance': 'Spara saldo',
  'bank.importFix.balanceWarnTitle': 'Ändra bara om saldot från kontoutdraget/importen är fel.',
  'bank.importFix.balanceWarnBody': 'IB hämtas normalt från föregående avstämda UB. Ursprungligt inläst saldo behålls.',
  'bank.importFix.resultPrefix': 'Med nuvarande hanterade bankrader blir saldoavvikelsen',
  'bank.importFix.whyBalance': 'Varför korrigeras saldot?',
  'bank.importFix.whyBalancePh': 'T.ex. UB lästes från fel rad i PDF:en',
  'bank.loan.intro': 'Använd detta för upptagna lån, amorteringar eller betalningar som kan delas upp i amortering, ränta och avgift. Valt konto hämtas från företagets aktiva kontoplan och bokföringen görs utan moms.',
  'bank.loan.account': 'Låne-/skuldkonto',
  'bank.loan.noAccount': 'Hittade inget vanligt låne-/skuldkonto i den aktiva kontoplanen. Skapa rätt konto eller använd fri kontering.',
  'bank.loan.principal': 'Amortering / lånebelopp',
  'bank.loan.splitMismatch': 'Uppdelningen måste stämma med bankbeloppet. Återstår: {{amount}} kr.',
  'bank.loan.docLinked': 'Dokumentation är kopplad.',
  'bank.loan.docRemember': 'Kom ihåg dokumentationen.',
  'bank.loan.docHelp': 'Ladda upp låneavtal, amorteringsplan eller annat underlag. Uppdelningen måste kunna dokumenteras.',
  'bank.loan.complex': 'Gäller raden närstående, ett ovanligt konto eller ett mer komplicerat låneförhållande?',
  'bank.loan.useFree': 'Använd fri kontering',
  'bank.group.err.sameDirection': 'Alla bankrader i en fördelningsgrupp måste ha samma riktning.',
  'bank.group.err.pickBoth': 'Välj båda bankraderna i överföringen.',
  'bank.group.toast.transferApproved': 'Överföringen har godkänts och bokförts samlat.',
  'bank.group.toast.allocationApproved': 'Fördelningen har godkänts och bokförts samlat.',
  'bank.group.err.approveFailed': 'Det gick inte att godkänna matchningsgruppen.',
  'bank.group.title': 'Matcha flera banktransaktioner',
  'bank.group.approve': 'Godkänn och bokför grupp',
  'bank.group.oneOperation': 'En kontrollerad åtgärd',
  'bank.group.oneOperationHelp': 'Gruppen reserverar alla valda bankrader. Bokföring och koppling sker samlat i backend när du godkänner.',
  'bank.group.matchType': 'Typ av matchning',
  'bank.group.typeAllocation': 'Fördela betalning mot öppna poster',
  'bank.group.typeTransfer': 'Intern överföring mellan egna konton',
  'bank.group.sourceLine': 'Rad från ett konto',
  'bank.group.counterLine': 'Motpost på eget konto',
  'bank.group.pickOpposite': 'Välj motsatt bankrad',
  'bank.group.transferRules': 'Endast samma datum och belopp, motsatt tecken och ett annat konfigurerat bankkonto erbjuds. Olika datum kräver ett transitkonto.',
  'bank.group.noOpenItems': 'Inga öppna {{kind}} kan allokeras.',
  'bank.group.customerInvoices': 'kundfakturor',
  'bank.group.supplierInvoices': 'leverantörsfakturor',
  'bank.group.itemRest': '{{number}} · {{party}} · rest {{amount}}',
  'bank.group.removeRow': 'Ta bort rad',
  'bank.corr.err.reasonVoid': 'Skriv kort varför konteringen makuleras.',
  'bank.corr.err.notFieldCorrectable': 'Den här posttypen kan inte fältkorrigeras från bankavstämningen. Makulera konteringen och bokför den rätt på nytt, eller öppna verifikationen i verifikationslistan.',
  'bank.corr.err.supplierPaymentVoid': 'Betalningar av leverantörsfakturor makuleras från leverantörsverifikationen.',
  'bank.corr.err.noSupportedAction': 'Hittade ingen åtgärd som stöds för den här bokförda posten.',
  'bank.receipt.toast.trashed': 'Verifikationen har flyttats till papperskorgen.',
  'bank.receipt.err.deleteFailed': 'Det gick inte att ta bort verifikationen.',
  'bank.receipt.deleting': 'Tar bort…',
  'bank.receipt.delete': 'Ta bort verifikation',
  'bank.mode.toFull': 'Byt till full översikt',
  'bank.mode.toGuided': 'Byt till steg för steg',
  'bank.import.toast.privateSaved': 'Privat kontoutdrag sparat - klart för genomgång',
  'bank.import.toast.saved': 'Bankutdrag sparat - klart för avstämning',
  'bank.inbox.view.statement': 'Det här utdraget',
  'bank.inbox.view.unlinked': 'Endast ej kopplade',
  'bank.inbox.view.all': 'Alla verifikationer',
  'bank.inbox.showInList': 'Visa i inkorgen',
  'bank.inbox.viewing': 'Visar: {{view}} · {{hidden}} dolda',
  'bank.inbox.waiting': '{{count}} verifikationer väntar på hantering',
  'bank.inbox.hide': 'Dölj inkorg',
  'bank.inbox.companyAddress': 'företagets verifikationsinkorg',
  'bank.inbox.defaultNote': 'Dra en verifikation till en bankrad eller låt SuperPlumma föreslå träffar.',
  'bank.inbox.uploadVoucher': 'Ladda upp verifikation',
  'bank.inbox.orDrag': 'Eller dra · släpp på en rad som saknar verifikation',
  'bank.inbox.dropHint': 'Släpp filer här för att ladda upp nya verifikationer.',
  'bank.inbox.noMatch': 'Inga verifikationer matchar sökningen.',
  'bank.inbox.noneInSelection': 'Inga verifikationer i det här urvalet · {{hidden}} dolda av filtret',
  'bank.inbox.allDone': 'Alla verifikationer är färdigbehandlade',
  'bank.inbox.empty': 'Inkorgen är tom',
  'bank.inbox.tip.showAll': 'Tryck för att visa alla bankrader igen',
  'bank.inbox.tip.showLine': 'Tryck för att visa bankraden som verifikationen är kopplad till',
  'bank.inbox.tip.linkedElsewhere': 'Kopplad utanför det här bankutdraget',
  'bank.inbox.linkedHere': 'Kopplad · {{label}}',
  'bank.inbox.linkedIn': 'Kopplad i {{label}}',
  'bank.inbox.previewName': 'Förhandsgranska {{name}}',
  'bank.inbox.voucherLower': 'verifikation',
  'bank.inbox.filteredOne': 'Filtrerat på en verifikation',
  'bank.inbox.filteredN': 'Filtrerat på {{count}} verifikationer',
  'bank.inbox.filterShowsLinked': 'Visar bara bankraderna som verifikationerna är kopplade till',
  'bank.inbox.showAllLines': 'Visa alla rader',
  'bank.inbox.nBankLines': '{{count}} bankrader',
  'bank.inbox.bankLineLower': 'bankrad',
  'bank.inbox.anotherStatement': 'ett annat bankutdrag',
  'bank.inbox.toast.linkedElsewhere': 'Verifikationen är kopplad till en bankrad i {{label}}.',
  'bank.resolve.annulText': 'Posten är dubbelbokförd. Återför den så att den inte räknas med. En eventuell verifikation läggs automatiskt tillbaka i inkorgen.',
  'bank.resolve.correctText': 'Bokföringen ska finnas kvar, men konto, moms eller intern beskrivning är fel. Bankbelopp och datum förblir låsta.',
  'bank.resolve.err.voidFailed': 'Det gick inte att makulera den bokförda posten.',
  'bank.resolve.voiding': 'Makulerar…',
  'bank.resolve.confirmVoid': 'Bekräfta makulering',
  'bank.resolve.voidReason': 'Orsak till makulering',
  'bank.resolve.voidReasonHint': 'Obligatoriskt. Motiveringen sparas i verifieringskedjan.',
  'bank.resolve.voidReasonPh': 'Beskriv kort varför konteringen ska makuleras',
  'bank.resolve.row.postedEntry': 'Bokförd post',
  'bank.resolve.row.account': 'Konto',
  'bank.resolve.row.vat': 'Moms',
  'bank.resolve.row.amount': 'Belopp',
  'bank.resolve.row.lineDate': 'Datum på bankraden',
  'bank.resolve.row.bankLine': 'Bankrad',
  'bank.resolve.row.voucher': 'Verifikation',
  'bank.resolve.row.notLinked': 'Inte kopplad',
  'bank.resolve.reopenAsDeviation': 'Öppna som avvikelse',
  'bank.resolve.releaseInvestmentMatch': 'Frigör bankkoppling',
  'bank.resolve.reverse': 'Återför',
  'bank.resolve.alreadyPosted': 'Den här bankraden är redan bokförd eller matchad. Den kan därför inte hanteras som en ny rad.',
  'bank.resolve.useCorrection': 'Använd korrigering för konto, moms eller intern beskrivning. Bankbelopp, datum och koppling förblir låsta.',
  'bank.resolve.reverseInfo': 'Återföring makulerar köpet med spårbarhet och öppnar bankraden för ny kontroll.',
  'bank.resolve.existingInfo': 'Detta är kopplat till en befintlig verifikation eller post. Korrigera själva verifikationen om underlaget är fel.',
  'bank.resolve.verifiableInfo': 'Den här kopplingen kan kontrolleras i postdetaljerna.',
  'bank.resolve.approving': 'Godkänner…',
  'bank.resolve.approveN': 'Godkänn {{count}} förslag',
  'bank.resolve.confirmIntro': 'Kontrollera sammanfattningen. Förslag som är matchade mot en befintlig post skapar ingen ny bokföring.',
  'bank.resolve.voucherReturns': 'Verifikationen ”{{name}}” läggs automatiskt tillbaka i inkorgen när posten makuleras.',
  'bank.err.uploadVoucherFailed': 'Det gick inte att ladda upp verifikationen.',
  'bank.drop.attachAsDoc': 'Bifogas som dokumentation',
  'bank.drop.uploadAnalyzeLink': 'Laddas upp, analyseras och kopplas',
  'bank.receipt.confirmDelete': 'Ta bort verifikationen från inkorgen? Den flyttas till papperskorgen och kan återställas.',
  'bank.percentDone': '{{pct}}% klart',
  'mypage.role.owner': 'Ägare',
  'mypage.role.admin': 'Administratör',
  'mypage.role.accountant': 'Redovisningskonsult',
  'mypage.role.viewer': 'Läsare',
  'mypage.shortcut.oversikt.title': 'Översikt',
  'mypage.shortcut.oversikt.text': 'Hälsopoäng och ekonomisk översikt för hushållet',
  'mypage.shortcut.forbruk.title': 'Förbrukning',
  'mypage.shortcut.forbruk.text': 'Vad pengarna går till, fördelat på kategorier',
  'mypage.shortcut.familie.title': 'Familj',
  'mypage.shortcut.familie.text': 'Gemensam budget och fördelning i hushållet',
  'mypage.shortcut.fremtid.title': 'Framtid',
  'mypage.shortcut.fremtid.text': 'Sparande, lån, pension och framtidsplaner',
  'mypage.shortcut.skatt.title': 'Skatt',
  'mypage.shortcut.skatt.text': 'Privat skattemelding, avdrag och uppskattning',
  'mypage.fallback.business': 'Företag',
  'mypage.fallback.signedInUser': 'Inloggad användare',
  'mypage.fallback.employerLoadError': 'Det gick inte att hämta arbetsgivare.',
  'mypage.verify.body': 'Vissa funktioner, bland annat klientinbjudningar och personalportalen, kräver att {{email}} är bekräftad. Skicka länken igen om du inte hittar den, öppna länken i e-postmeddelandet och tryck sedan på att du har bekräftat.',
  'mypage.verify.resend': 'Skicka bekräftelse igen',
  'mypage.verify.sending': 'Skickar...',
  'mypage.verify.confirmed': 'Jag har bekräftat',
  'mypage.verify.checking': 'Kontrollerar...',
  'mypage.err.profileNotConnected': 'Profilsparning är inte kopplad till backend.',
  'mypage.toast.profileUpdated': 'Profilen har uppdaterats',
  'mypage.err.profileUpdateFailed': 'Det gick inte att uppdatera profilen.',
  'mypage.err.verifyNotConnected': 'E-postbekräftelse är inte kopplad till backend.',
  'mypage.toast.alreadyVerified': 'E-postadressen är redan bekräftad.',
  'mypage.toast.verifyResent': 'Bekräftelselänken har skickats igen.',
  'mypage.err.verifySendFailed': 'Det gick inte att skicka bekräftelselänken.',
  'mypage.err.verifyStatusFailed': 'Det gick inte att kontrollera e-poststatus.',
  'mypage.toast.emailVerified': 'E-postadressen är bekräftad.',
  'mypage.toast.stillUnverified': 'Adressen är fortfarande inte bekräftad. Kontrollera inkorgen och försök igen.',
  'mypage.err.personalNotConnected': 'Privatekonomi är inte kopplad till backend i den här versionen.',
  'mypage.toast.personalCreated': 'Privatekonomi har skapats',
  'mypage.err.personalCreateFailed': 'Det gick inte att skapa privatekonomi.',
  'mypage.toast.openPersonalForFamily': 'Öppna Privatekonomi för att ändra Familj.',
  'mypage.toast.familyEnabled': 'Familj har aktiverats.',
  'mypage.toast.familyDisabled': 'Familj har inaktiverats.',
  'mypage.err.familySaveFailed': 'Det gick inte att spara inställningen för Familj.',
  'mypage.titleHelp': 'Min sida är ditt personliga konto i Plumme — separat från själva bokföringen. Här ser du din profil, de verksamheter du har åtkomst till, de arbetsgivare du är anställd hos och ingången till din privatekonomi.',
  'mypage.field.memberSince': 'Medlem sedan',
  'mypage.toast.onboardingNotLoaded': 'Introduktionen har inte laddats ännu.',
  'mypage.orgNumber': 'Org. {{orgnr}}',
  'mypage.biz.loadingTitle': 'Hämtar verksamheter',
  'mypage.biz.loadingText': 'Ansluter till Plumme backend.',
  'mypage.biz.emptyTitle': 'Inga egna företag',
  'mypage.biz.emptyText': 'Du kan skapa ett företag här senare, även om du bara använder Plumme som redovisningskonsult eller privatanvändare.',
  'mypage.clients.title': 'Klientuppdrag',
  'mypage.clients.help': 'Företag där du är inbjuden som redovisningskonsult, administratör eller läsare. Klientdata hålls åtskilda från egna företag och Privatekonomi.',
  'mypage.clients.setup': 'Inställningar för redovisningskonsult',
  'mypage.clients.access': 'Klientåtkomst',
  'mypage.clients.empty': 'Du har inga aktiva klientuppdrag. Inbjudningar visas globalt efter inloggning.',
  'mypage.pf.creating': 'Skapar...',
  'mypage.pf.create': 'Skapa privatekonomi',
  'mypage.pf.intro': 'Din personliga rådgivare för hushållsekonomin - åtskild från verksamheternas bokföring. Välj en översikt för att komma igång.',
  'mypage.pf.family': 'Familj',
  'mypage.pf.familyText': 'Visa sidan Familj i Privatekonomi.',
  'mypage.pf.emptyIntro': 'Skapa en privatekonomiklient för att samla privat översikt, import, hushåll, skatt och rapporter utan att blanda det med redovisningsklienterna.',
  'mypage.emp.fallbackRole': 'Anställd',
  'mypage.emp.loadingTitle': 'Hämtar arbetsgivare',
  'mypage.emp.emptyTitle': 'Inga arbetsgivare',
  'mypage.emp.loadingText': 'Ansluter till personalportalen.',
  'mypage.emp.emptyText': 'Ingen åtkomst till personalportalen är registrerad för användaren.',
  'mypage.err.passwordResetNotConnected': 'Återställning av lösenord är inte kopplad till backend.',
  'mypage.toast.passwordLinkSent': 'En länk för att ändra lösenord har skickats via e-post',
  'mypage.err.passwordLinkFailed': 'Det gick inte att skicka lösenordslänken.',
  'mypage.saving': 'Sparar...',
  'mypage.hh.loadError': 'Det gick inte att hämta hushållskopplingen.',
  'mypage.hh.updateError': 'Det gick inte att uppdatera hushållet.',
  'mypage.hh.inviteEmailFailed': 'Inbjudan har skapats, men e-postmeddelandet kunde inte skickas. Du kan försöka igen.',
  'mypage.hh.inviteSent': 'Inbjudan har skapats och skickats.',
  'mypage.hh.left': 'Hushållskopplingen har avslutats.',
  'mypage.hh.hiddenPending': 'Inbjudan har dragits tillbaka och tagits bort från listan.',
  'mypage.hh.hidden': 'Inbjudan har tagits bort från listan.',
  'mypage.hh.loading': 'Hämtar hushållsstatus …',
  'mypage.hh.partnerFallback': 'Ansluten partner',
  'mypage.hh.twoAccounts': 'Två separata konton · delad Familj-sida',
  'mypage.hh.leaveConfirm': 'Koppla från hushållet? Båda behåller sina egna data, medan den delade Familj-profilen avslutas.',
  'mypage.hh.leaving': 'Kopplar från …',
  'mypage.hh.leave': 'Koppla från hushållet',
  'mypage.hh.inviteIntro': 'Bjud in en partner via e-post. Mottagaren kan logga in eller skapa ett nytt Plumme-konto och får hjälp att skapa Privatekonomi innan kopplingen godkänns.',
  'mypage.hh.inviting': 'Skapar …',
  'mypage.hh.invite': 'Bjud in partner',
  'mypage.hh.userFallback': 'Plumme-användare',
  'mypage.hh.joined': 'Hushållet har kopplats ihop.',
  'mypage.hh.sentInvites': 'Skickade inbjudningar',
  'mypage.hh.resendFailedToast': 'Inbjudan är aktiv, men e-postmeddelandet kunde inte skickas.',
  'mypage.hh.resentToast': 'Inbjudan har skickats igen.',
  'mypage.hh.resend': 'Skicka igen',
  'mypage.hh.remind': 'Påminn',
  'mypage.hh.withdrawn': 'Inbjudan har dragits tillbaka.',
  'mypage.hh.removeFromList': 'Ta bort från listan',
  'mypage.hh.status.pending': 'Väntar på svar · {{delivery}}',
  'mypage.hh.status.expired': 'Utgången',
  'mypage.hh.status.declined': 'Avböjd',
  'mypage.hh.status.canceled': 'Tillbakadragen',
  'mypage.hh.status.accepted': 'Accepterad',
  'mypage.hh.delivery.delivered': 'e-post levererad',
  'mypage.hh.delivery.opened': 'e-post öppnad',
  'mypage.hh.delivery.clicked': 'länk öppnad',
  'mypage.hh.delivery.failed': 'e-post misslyckades',
  'mypage.hh.delivery.bounced': 'e-post avvisad',
  'mypage.hh.delivery.complained': 'markerad som skräppost',
  'mypage.hh.delivery.delivery_delayed': 'e-post försenad',
  'mypage.hh.delivery.sent': 'e-post skickad',
  'audit.domain.settings': 'Inställningar',
  'audit.domain.invoices': 'Faktura',
  'audit.domain.sales': 'Försäljning',
  'audit.domain.expenses': 'Köp',
  'audit.domain.customers': 'Kunder',
  'audit.domain.products': 'Produkter',
  'audit.domain.suppliers': 'Leverantörer',
  'audit.domain.inbox': 'Inkorg',
  'audit.domain.bank': 'Bank',
  'audit.domain.mileage': 'Körjournal',
  'audit.domain.payroll': 'Lön',
  'audit.domain.business': 'Företag',
  'audit.domain.access': 'Behörigheter',
  'audit.summary.rows': '{{count}} rader',
  'audit.summary.fields': '{{count}} fält',
  'audit.event.updated': 'Uppdaterade {{domains}}',
  'audit.event.updatedBusinessData': 'Uppdaterade företagets data',
  'audit.event.businessCreated': 'Skapade företaget',
  'audit.event.inviteCreated': 'Bjöd in {{email}} som {{role}}',
  'audit.event.inviteAccepted': '{{user}} accepterade inbjudan',
  'audit.event.deletionRequestedFor': 'Begärde borttagning av företaget {{date}}',
  'audit.event.deletionRequested': 'Begärde borttagning av företaget',
  'audit.event.deletionCanceled': 'Avbröt borttagning av företaget',
  'audit.fallback.newUser': 'ny användare',
  'audit.fallback.userLower': 'användare',
  'audit.fallback.user': 'Användare',
  'audit.fallback.unknownUser': 'Okänd användare',
  'audit.err.loadFailed': 'Det gick inte att hämta aktivitetsloggen.',
  'audit.meta.time': 'Tidpunkt',
  'audit.meta.user': 'Användare',
  'audit.meta.role': 'Roll',
  'audit.meta.action': 'Åtgärd',
  'audit.meta.source': 'Källa',
  'audit.meta.invite': 'Inbjudan',
  'audit.meta.targetUser': 'Målanvändare',
  'audit.detail.before': 'Före:',
  'audit.detail.after': 'Efter:',
  'audit.titleHelp': 'Aktivitetsloggen är en revisionslogg: den visar alla viktiga åtgärder som har gjorts i bokföringen - vem som gjorde vad, när och inom vilket område. Användbar för spårbarhet och kontroll när flera samarbetar.',
  'audit.search': 'Sök i aktivitetsloggen för {{year}}',
  'audit.scope.all': 'Alla',
  'audit.scope.others': 'Andra',
  'audit.scope.mine': 'Jag',
  'audit.scope.access': 'Behörigheter',
  'audit.col.event': 'Händelse',
  'audit.empty.loadingTitle': 'Hämtar aktivitetslogg',
  'audit.empty.loadingText': 'Ansluter till Plumme backend.',
  'audit.empty.noMatchTitle': 'Inga träffar',
  'audit.empty.noMatchText': 'Inga aktiviteter matchar filtret. Försök att återställa det.',
});
